import { isSSR } from '../../utils/renderContext';

// Gatsby renders both on server during build and on the client
// occassionally we want to limit components to client only
// eg: when it requires access to document/window. 
const RenderOnClientOnly = ({ children }) => isSSR() ? null : children;

export default RenderOnClientOnly;